import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["minBreakpoint", "maxBreakpoint"];
import styled from 'styled-components';
import UIGrid from 'UIComponents/grid/UIGrid';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledHeaderGrid = styled(props => {
  const rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(UIGrid, Object.assign({}, rest));
}).withConfig({
  displayName: "StyledHeaderGrid",
  componentId: "ab3817-0"
})(["&&{margin:auto;width:60%;&.sticky{width:100%;}@media only screen and (min-width:", ") and (max-width:", "){width:80%;}@media only screen and (max-width:", "){width:95%;}}"], props => props.minBreakpoint, props => props.maxBreakpoint, props => props.minBreakpoint);
export default StyledHeaderGrid;